export const PLAN_FREE = 'free';
export const PLAN_PROFESSIONAL = 'professional';
export const PLAN_ENTERPRISE = 'enterprise';
